import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ttInputSuffix]',
  standalone: true,
})
export class InputSuffixDirective {
  @HostBinding('class.tt-input-suffix') TTInputSuffix = true;
}
